import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { Patient } from "@models/patient";

export enum Mode {
  Caregiver = "Caregiver",
  Patient = "Patient",
}

export interface HomeState {
  selectedPatientId: string | null;
  selectedPatient: Patient | null;
  patients: Patient[];
  mode: Mode;
}

const initialState: HomeState = {
  selectedPatientId: null,
  selectedPatient: null,
  patients: [],
  mode: Mode.Caregiver,
};

export const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    selectPatientId: (state, action: PayloadAction<string | null>) => {
      state.selectedPatientId = action.payload;
    },
    setPatients: (state, action: PayloadAction<Patient[]>) => {
      state.patients = action.payload;
    },
    setSelectedPatient: (state, action: PayloadAction<Patient | null>) => {
      state.selectedPatient = action.payload;
    },
    setCompanionMode: (state, action: PayloadAction<Mode>) => {
      state.mode = action.payload;
    },
  },
});

export const {
  selectPatientId,
  setPatients,
  setSelectedPatient,
  setCompanionMode,
} = homeSlice.actions;

export default homeSlice.reducer;
